<template>
  <section
      class="Modal ModalCalendar"
      @click.self="closeModal"
      v-show="showModal"
      :class="[{ display: showModal }, isZeborne ? 'zeborne' : 'mcp',]"
      ref="calendar"
  >
    <!-- Header -->
    <div class="Modal-header">
      <span @click="closeModal">fermer</span>
      <div class="Modal-close" @click="closeModal">
        <svg v-svg symbol="Close" size="0 0 16 16" role="presentation" class="icon--inline"></svg>
      </div>
    </div>
    <!-- Inner -->
    <div class="Modal-inner">
      <div class="Modal-content">

        <!-- Loaders -->
        <div v-if="isZeborne" class="Modal-loader" :class="{ display: loadSpinner }">
          <div></div>
        </div>

        <McpWheelLoader 
          v-if="!isZeborne"
          :display="loadSpinner"
        />
        
        <!-- Intervention type title -->
        <ModalCalendarTitle
          :deliveryType="deliveryType"
          :landingLeadType="landingLeadType"
          :fromLanding="fromLanding"
          :slotsChoiceActive="slotsChoiceActive"
          :landingCategoryName="landingCategoryName"
        />

        <div v-if="!slotsChoiceActive" class="landing-slotChoiceInactive">
          <p class="landing-slotChoiceInactive__additionalText">
            Si vous souhaitez que notre équipe vous rappelle pour échanger à propos de votre projet de rénovation, remplissez le formulaire ci-dessous. Notre équipe traitera votre demande dans les meilleurs délais.
          </p>
        </div>

        <!-- STEP 1 Postal code/Calendar-->
        <section :class="{'done': step > 1}">
          <!-- title -->
          <div v-if="slotsChoiceActive && step<= 1" class="Step-title"><span class="bullet number">1</span> Vérifiez votre éligibilité</div>
          <div v-else-if="slotsChoiceActive" class="Step-title"><span class="bullet number">1</span> {{ deliverySubTitleWord }} planifiée le</div>
          <div v-else-if="!slotsChoiceActive && fromLanding" class="Step-title"><span class="bullet number">1</span>Votre lieu d’installation</div>
          
          <div v-show="step === 1" class="calendar__container">
            <!-- Input Postal Code -->
            <div class="Form-inputText">
              <input
                  type="number"
                  id="postal-code"
                  name="postalCode"
                  @keyup="blurAction($event.target.value)"
                  @keydown="preventPostalCodeMaxLength($event)"
                  :value="postalCodeValue"
                  class="topLabel"
                  ref="postalCodeInput"
                  max="99999"
                  required
                  pattern="[0-9]{5}"
              />
              <label for="postal-code">Code postal*</label>
              <div class="successIcon">
                <svg
                    v-svg
                    symbol="ValideGreen"
                    size="0 0 12 12"
                    role="presentation"
                    class="icon--inline Icon-Valide"
                ></svg>
              </div>
            </div>

            <!-- Success Message -->
            <div class="Messages success" v-if="eligibilitySuccess && !hideElement">
              <span class="grayText">Vous êtes éligible à notre agence</span>
              <div class="Modal-agencyName">
                <svg
                    v-svg
                    symbol="Map"
                    size="0 0 12 12"
                    role="presentation"
                    class="icon--inline Icon-Map"
                ></svg>
                {{ agency.name }}
              </div>
              <div class="Modal-eligibilityLogos">
                <img :src="agency.logo" alt="agency logo" />
              </div>
            </div>

            <!-- Error Message -->
            <Messages
                v-if="!eligibilitySuccess && errorMessage"
                :text="errorMessage"
                :type="'danger'"
            ></Messages>

            <!-- Separator -->
            <div class="Modal-separator" v-if="!callSuccess"></div>

            <!-- Calendar -->
            <div v-if="eligibilitySuccess && !hideElement && slotsChoiceActive" class="Modal-Calendar">
              <div class="Step-title"><span class="bullet number">2</span> Choisissez le jour et l'heure {{ deliveryTypeWord }}</div>

              <Messages
                v-if="error_slot_process"
                :text="errorMessage"
                :type="'danger'"
              ></Messages>

              <Calendar
                  @Calendar::close="handleModalClosure"
                  :needReload="needReloadData"
                  :updateModal="updateModal"
                  :deliveryTypeWord="deliveryTypeWord"
              ></Calendar>
            </div>

            <!-- Info -->
            <div class="Modal-info" v-if="eligibilitySuccess && !hideElement && slotsChoiceActive">
              <svg
                  v-svg
                  symbol="Timer"
                  size="0 0 24 24"
                  role="presentation"
                  class="icon--inline Icon-Timer"
              ></svg>
              <span>
              Une fois sélectionné, votre créneau est valable pendant 2 heures jusqu'à la validation de
              votre commande
              </span>
            </div>
            <div v-if="eligibilitySuccess && !hideElement && !slotsChoiceActive">
              <button 
                class="Button Button-primary"
                @click.prevent="handleModalClosure()">Suivant</button>
            </div>
          </div>
        </section>

        <section
            v-if="deliveryType === 'intervention' || isLead"
            class="CartRecap CheckoutRecap">
          <div
              v-show="step === 2">

              <div class="Modal-back" @click.prevent="step = 1">
                <svg
                    v-svg
                    symbol="Arrow_Left"
                    size="0 0 16 16"
                    role="presentation"
                    class="icon--inline Icon-Arrow"
                ></svg>
              </div>
            <!-- Calendar -->
            <div v-if="slotsChoiceActive" class="productShippingMethods-modal">
              <!-- Message if already selected -->
              <div
                  class="ProductShipping-messagesSelected"
                  v-if="selectedDeliveryDateStart !== ''"
              >
                <p>
                  <span class="title">Rendez-vous prévu</span><br>
                  <span class="slot">{{ selectedDeliveryDateStart | formatDate }} entre {{ selectedDeliveryHours }} <svg
                      v-svg
                      symbol="ValideGreen"
                      size="0 0 12 12"
                      role="presentation"
                      class="icon--inline Icon-Valide override-icon"
                  ></svg></span>
                </p>
                <!-- Modify link -->
                <button @click.prevent="step = 1">modifier</button>
              </div>
            </div>
            <WizardInfo
                @checkout="saveWizard()"
                @next-step="nextStep()"
            />
          </div>
        </section>
        
        <section
            v-show="(deliveryType === 'intervention' || productStrapiFormId) && step === 3"
            class="CartRecap CheckoutRecap">
            <div class="Modal-back" @click.prevent="prevStep">
              <svg
                  v-svg
                  symbol="Arrow_Left"
                  size="0 0 16 16"
                  role="presentation"
                  class="icon--inline Icon-Arrow"
              ></svg>
            </div>
          <WizardForm
            :isLandingOrLead="isLead || fromLanding"
            @checkout="saveWizard()" />
        </section>

        <section class="additionalOptionStep">
          
          <div v-show="step === 4">
            <!-- Arrow back -->
            <div >
              <div class="Modal-back" @click.prevent="step = 1">
                  <svg
                      v-svg
                      symbol="Arrow_Left"
                      size="0 0 16 16"
                      role="presentation"
                      class="icon--inline Icon-Arrow"
                  ></svg>
              </div>

              <!-- Calendar -->
              <div class="productShippingMethods-modal">

                <!-- Message if already selected -->
                <ProductShippingMessages
                  :selectedDeliveryDateStart="selectedDeliveryDateStart"
                  :selectedDeliveryHours="selectedDeliveryHours"
                  :fromModalCalendar="true"
                  @modifySlot="step = 1"
                />
              </div>
            </div>
          </div>

          <div class="additionalOptions__container" v-if="additionalOptionsArray.length > 0 && fromLanding === false">
            <!-- title -->
            <div class="Step-title" :class="step !== 4 ? 'disabled' : ''">
              <span class="bullet number">2</span>
              Vos options
            </div>

            <div v-show="step === 4" class="CartResumeAdditionalOption-card FormItemsList">
              <!-- Loader -->
              <div class="Modal-loader" :class="{ display: loadOptionsLoader }">
                <svg
                    v-svg
                    symbol="Loader"
                    size="0 0 80 80"
                    role="presentation"
                    class="icon--inline"
                ></svg>
              </div>

              <ProductEssentialOptions
                v-for="(additionalOption, index) in additionalOptionsArray"
                :key="index"
                :essentialOption="additionalOption"
                :preSelected="false"
                :classProps="index%2 == 0 ? 'left' : 'right'"
                @toggleLoader="togleOptionsLoader"
              ></ProductEssentialOptions>
            </div>
          </div>
          
        </section>
      </div>

      <div v-if="!monthlyPayment && !financingLayer && showPrice && !isLead && !fromLanding" class="bottom-actions">
        <div class="cart-totals">
          <p class="title">Total</p>
          <ProductPriceRecap
            :originalPrice="currentCartTotal"
            :ecoTaxe="ecoTaxe"

          ></ProductPriceRecap>
          <p class="title" v-if="reducedTaxRate == originalTva || productCurrentTva == originalTva">TVA {{productCurrentTva | formatNumber(2) }}%</p>
        </div>
        <div class="purchase-button">
          <div class="CartRecap-submit">
            <ProgressFillButton
              v-if="isLead"
              :percent="step * 25"
              @order="handleAddToCart"></ProgressFillButton> 
          </div>
        </div>
      </div>
      <div class='custom_clid'>
        <div id="gclid-form-wrapper">
        <form action="#" name="myForm">
            <input type="hidden" id="gclid_field" name="gclid_field" value="">
        </form>
        </div>

        <div id="fbclid-form-wrapper">
            <form action="#" name="myFormFb">
                <input type="hidden" id="fbclid_field" name="fbclid_field" value="">
        </form>
        </div>
      </div> 
    </div>
  </section>
</template>

<script>
import TopLabelMixin from "@/mixins/topLabelMixin";
import selectSlotMixin from "@/mixins/actions/cart/selectSlotMixin";
import clearQuoteMixin from "@/mixins/actions/cart/clearQuote";
import InstanceApi from "@/services/apiClient.js";
import Messages from "@/components/Messages/Messages.vue";
import Calendar from "@/components/Calendar/Calendar.vue";
import WizardInfo from "@/components/Wizard/WizardInfo/WizardInfo.vue";
import WizardForm from "@/components/Wizard/WizardForm/WizardForm.vue";
import ProgressFillButton from "@/components/ProgressButton/ProgressFillButton.vue";
import EventBus from "@/event-bus";
import { mapActions, mapGetters } from "vuex";
import ProductPriceRecap from "@/includes/Product/ProductPrice/ProductPriceRecap.vue";
import addItemToCartMixin from "@/mixins/actions/cart/addItemToCartMixin.js";
import CartResumeAdditionalOptionCard from "@/includes/Cart/CartResumeAdditionalOptionCard/CartResumeAdditionalOptionCard.vue";
import ProductEssentialOptions from "@/includes/Product/ProductEssentialOptions/ProductEssentialOptions.vue";
import ProductShippingMessages from "@/includes/Product/ProductShippingMessages/ProductShippingMessages.vue";
import McpWheelLoader from '@/components/Loaders/McpWheelLoader.vue';
import ModalCalendarTitle from './modalCalendarIncludes/ModalCalendarTitle.vue';
import { preventPostalCodeMaxLength } from "@/services/validations.js";

import "@/components/Modal/Modal.scss";

export default {
  name: "ModalCalendar",
  mixins: [TopLabelMixin, selectSlotMixin, clearQuoteMixin, addItemToCartMixin],

  components: {
    Messages,
    Calendar,
    WizardInfo,
    WizardForm,
    ProgressFillButton,
    ProductPriceRecap,
    CartResumeAdditionalOptionCard,
    ProductEssentialOptions,
    ProductShippingMessages,
    McpWheelLoader,
    ModalCalendarTitle,
  },

  props: {
    showModal: Boolean,
    deliveryType: String,
    deliveryId: String,
    fromLanding: {
      type: Boolean,
      default: false,
    },
    /* Use different call from cart page */
    fromCartPage: {
      type: Boolean,
      default: false,
    },
    onModify: {
      type: Boolean,
      default: false,
    },
    needReload: {
      type: Boolean,
      default: false,
    },
    clearZipcode: false,
    hideElement: false,
    landingLeadType: {
      type: String,
      default: ""
    },
    slotsChoiceActive: {
      type: Boolean,
      default: true,
    },
    landingCategoryName: {
      type: String,
      default: ""
    }
  },

  computed: {
    ...mapGetters({ productId: "getProductId" }),
    ...mapGetters({ agency: "getSelectedDeliveryAgenciesData" }),
    ...mapGetters({ postalCode: "getDeliverySelectedPostalCode" }),
    ...mapGetters({
      selectedDeliveryDateStart: "getDeliverySelectedDateStart",
      selectedDeliveryId: "getDeliverySelectedId",
      selectedDeliveryHours: "getDeliverySelectedHours",
      getWizardPercentFillLast: "getWizardPercentFillLast",
      isZeborne: "isZeborne",
      isLead: "isLead",
      additionalOptionsArray: "getCurrentCartAdditionalOptions",
      preprendCartData: "getPreprendCartData",
      taxProfile: "getTaxProfile",
      productCurrentTva: "getProductTVAForCurrentDelivery",
      currentCartTotal: "getCurrentCartTotal",
      deliveryInfos: "getDelivery",
      originalTva: "getProductOriginalTVA",
      reducedTaxRate: "getProductReducedTaxRate",
      storeUrlPrefix: "getStoreUrlPrefix",
      wizardRequiredInfo: "getWizardInfoRequired",
      shippingMethodPrice: "getShippingMethodSelectedSpecialPrice",
      productStrapiFormId: "getProductFormStrapiId",
      productShippingInfo: "getProductShippingInfo",
      productPreprendCatQty: "getPreprendCartQuantity",
      wizardSrapiForm: "getWizardStrapiForm",
      productShippingList: "getProductShippingMethods",
    }),
    ...mapGetters({ storeUrlPrefix: "getStoreUrlPrefix" }),
    
    deliveryTypeWord() {
      let word = "";
      if (this.deliveryType === "delivery_only" || this.deliveryType === "standard_delivery") {
        word = "de la livraison";
      }
      if (
          this.deliveryType === "installation" ||
          this.deliveryType === "delivery_and_installation"
      ) {
        word = "de l'installation";
      }
      if (this.deliveryType === "intervention") {
        word = "du rendez-vous";
      }
      if (this.isLead) {
        word = "de la visite technique";
      }
      return word;
    },

    deliverySubTitleWord() {
      let subTitleWord = "";
      if (this.deliveryType === "delivery_only" || this.deliveryType === "standard_delivery") {
        subTitleWord = "Livraison";
      }
      if (
          this.deliveryType === "installation" ||
          this.deliveryType === "delivery_and_installation"
      ) {
        subTitleWord = "Installation";
      }
      if (this.deliveryType === "intervention") {
        subTitleWord = "Rendez-vous";
      }
      if (this.isLead) {
        subTitleWord = "Visite technique";
      }
      return subTitleWord;
    },

    ModalTitle() {
      let title = "";
      if (this.deliveryType === "delivery_only" || this.deliveryType === "standard_delivery") {
        title = "Planifier ma livraison";
      }
      if(this.deliveryType === "intervention") {
        title = "Planifier mon intervention";
      }
      if (
          this.deliveryType === "installation" ||
          this.deliveryType === "delivery_and_installation"
      ) {
        title = "Configurer et planifier mon installation";
      }

      if (this.isLead || this.fromLanding) {
        title = (this.landingLeadType == "VIDEO_ASSISTANCE" && this.landingCategoryName != "Chauffe-eau électrique") ? "Planifier mon rendez-vous de visio-assistance" :
           this.landingCategoryName == "Chauffe-eau électrique" ? "Planifier mon rendez-vous téléphonique" : "Planifier ma visite technique";
      }

      if(this.fromLanding && !this.slotsChoiceActive){
        if(this.landingCategoryName != "") {
          title = `Devis ${this.landingCategoryName.toLowerCase()}`
        } else {
          title = "Obtenir un devis";
        }       
      }

      return title;
    },

    ProductCurrentPrice() {
      let currentPrice;
      
      if(this.productShippingInfo.prices.finalPrice) {
        currentPrice = this.productShippingInfo.prices?.finalPrice[this.productCurrentTva] ? this.productShippingInfo.prices?.finalPrice[this.productCurrentTva] : this.productShippingInfo.prices?.price[this.productCurrentTva];
      }

      return currentPrice;
    }
  },

  data() {
    return {
      eligibilitySuccess: false,
      callSuccess: false,
      error_slot_process: false,
      errorMessage: "",
      loadSpinner: false,
      loadOptionsLoader: false,
      postalCodeValue: "",
      needReloadData: false,
      updateModal: false,
      step: 1,
      showPrice: false,
      hasStrapiForm : false,
    };
  },
  
  async beforeMount() {
    if(!this.onModify && !this.fromLanding) {

      if(!this.financingLayer){
        let apiUrlAddToCart = "mcp/cart/add/product/";
        let productQty

        Object.keys(this.preprendCartData).forEach(key => {
          if (this.preprendCartData[key] !== "") {
            if(key == 'need_cart_cleaning') {
              this.preprendCartData[key] = 'true';
            }
            if(key == 'qty') {
              productQty = this.preprendCartData[key]
            }
            apiUrlAddToCart = apiUrlAddToCart + "/" + key + "/" + this.preprendCartData[key];
          }
        });

        // ADD TAX PROFILE
        if(this.taxProfile[this.productCurrentTva] !== undefined) {
          Object.keys(this.taxProfile[this.productCurrentTva]).forEach(key => {
            if (this.taxProfile[this.productCurrentTva][key] !== "") {
              apiUrlAddToCart = apiUrlAddToCart + "/" + key + "/" + this.taxProfile[this.productCurrentTva][key];
            }
          });
        }
        

        try {
          this.toogleSpinner();

          const response = await InstanceApi.get(apiUrlAddToCart);
          if (response.status && response.status === 200) {
            this.updateCurrentCartRecaps(response.data);
            this.showPrice = true;

            this.toogleSpinner();
            this.dataLayerEvent('add_to_cart'); // also fired when intervention product is selected on slot selection, not good
          }
        } catch (error) {
          this.toogleSpinner();
          this.$fire({
            title: "Oups",
            text: "Une erreur est survenu lors de l'ajout au panier",
            type: "error",
            timer: 1500,
            position: "top-end",
          });
        }
      }else{
        try {
          let financingLayerBlockUrl = "mcp/cms/financing";
          const response = await InstanceApi.get(financingLayerBlockUrl);
          this.financingBlock = response.data;
          this.toogleSpinner();

        } catch (error) {
          this.$fire({
            title: "Oups",
            text: "Une erreur est survenue lors de la récupération des informations de financement",
            type: "error",
            timer: 1500,
            position: "top-end",
          });
        }
      }
    }
  },

  mounted() {
    EventBus.$on('toggleLoader',() => this.toogleSpinner());

    if(this.fromLanding || this.isLead) this.tabFocusEvent()

    if (this.showModal) {
      document.getElementsByTagName("body")[0].classList.add("fixed", "modal-open");
    }

    if (this.onModify) {
      this.postalCodeValue = this.postalCode;
      /* this.eligibilitySuccess = true; */
      this.verifyEligibility(this.postalCodeValue);
      this.toogleSpinner();

      if(this.isZeborne || (this.agency && Object.keys(this.agency).length === 0)){ // in case we modify the intervention selected on a previous page and not the current one, the agency data is empty so we need to reload it
        this.clearZipcode = false;
        this.needReload = true;
      }
      
    } else {
      this.postalCodeValue = "";
    }

    if(this.clearZipcode) {
      this.postalCodeValue = "";
      this.clearZipcode = false;
    }

    if (this.needReload && !this.fromCartPage) {
      this.updateModal = this.needReload;
      this.needReloadData = this.needReload;
      this.verifyEligibility(this.postalCodeValue);
      this.needReload = false;
    }

    if (this.deliveryType === 'intervention' && this.selectedDeliveryDateStart !== '') {
      this.step = 2;
    }

    if(!this.fromLanding && this.productStrapiFormId){
      this.initStrapiForm();
    }

    // this.step = 3;
  },

  methods: {
    /** Handle modal closure */
    async handleModalClosure () {
      this.toogleSpinner();
      const data = await this.selectSlot();
      this.error_slot_process = false;
      this.toogleSpinner();

      if (this.deliveryType === 'intervention' || this.isLead) {
        // call cart selectSlot
        //const data = await this.selectSlot();
        this.step = 2;

        if(this.isLead){
          EventBus.$emit("add-to-cart-noRedirect");
        }

        return;
      }

      if (!this.onModify)  {

        if(!this.fromCartPage && this.deliveryInfos.interventProductID) {
          await this.addItemToCart(this.deliveryInfos.interventProductID);
          this.$emit("Modal::close");
          EventBus.$emit("submit-form");
        } else {
          EventBus.$emit("submit-form");
        } 
        
        return;


        // Display ProductShippingMessages
        /* this.step = 4; */
      } else {
        this.closeModal();
      }

      /* call to select slot and update price if necessary */
      if(!this.fromCartPage){
        if(this.deliveryInfos.interventProductID){
          this.addItemToCart(this.deliveryInfos.interventProductID)
        }
      }
    },

    /* Handle add to cart */
    handleAddToCart() {
      if (this.step === 4) {
        this.closeModal();
        EventBus.$emit("submit-form");
      }
    },
    /** Close Modal */
    closeModal() {
      this.needReload = this.updateModal;
      document.getElementsByTagName("body")[0].classList.remove("fixed");

      if(!this.onModify && !this.fromCartPage) {
        this.toogleSpinner();
        this.clearQuote();
      }else {
        this.$emit("Modal::close");
      }
    },

    /** Show - Hide loader  */
    toogleSpinner() {
      this.loadSpinner = !this.loadSpinner;
    },

    /** Show - Hide loader for additional Options  */
    togleOptionsLoader() {
      this.loadOptionsLoader = !this.loadOptionsLoader;
    },

    blurAction(postalCode) {
      if (!this.needReload && postalCode === this.postalCodeValue) return;
      if (((this.storeUrlPrefix === undefined || this.storeUrlPrefix == "") && postalCode.length !== 5) || (this.storeUrlPrefix == "/be" && postalCode.length !== 4)) return;
      this.toogleSpinner();
      this.$refs.postalCodeInput.blur();
      this.verifyEligibility(postalCode);
    },

    // ============== ON CHANGE : POSTAL CODE ==================

    /** On input change, verify eligibility by postal code */
    verifyEligibility(postalCode) {
      if (this.needReload && !this.fromCartPage) {
        this.toogleSpinner();
      }
      if(this.hideElement) {
        this.hideElement = false;
      }

      let deliveryOnly = this.deliveryType === "delivery_only" || this.deliveryType === "standard_delivery" ? 1 : 0;
      try {
        localStorage.setItem("delivery_only", deliveryOnly);
      } catch (error) {
        console.error(error);
      }

      this.setPreprendCartDeliveryOnly(deliveryOnly);

      this.postalCodeValue = postalCode;
      /** Create Url for Api Call */
      const addUrl =
          "mcp/product/slots/id/" +
          this.productId +
          "/postcode/" +
          postalCode +
          "/delivery-only/" +
          deliveryOnly +
          "/delivery-type/" +
          this.deliveryType;

      this.callApi(addUrl);
      this.setSelectedDeliveryPostalCode(postalCode);

      // Gtm Event
      this.dataLayerEvent('postal_code')

    },

    /** Api Call */
    async callApi(addUrl) {
      await InstanceApi.get(addUrl)
          .then(response => {
            /** Set Data on Success */
            this.callSuccess = true;
            if (response.data instanceof Object) {
              const agency = response.data.agency;
              this.setSelectedDeliveryCalendarData({
                firstDate: response.data.firstDate,
                lastDate: response.data.lastDate,
                selectedDate: response.data.selectedDate,
                slots: response.data.slots,
              });

              this.setSelectedDeliveryAgenciesData({
                name: agency.name,
                image: process.env.VUE_APP_API_BASE_URL + "/media/" + agency.image,
                logo: process.env.VUE_APP_API_BASE_URL + "/media/" + agency.logo,
              });

              this.setSelectedDeliveryId(this.deliveryId);
              this.setCurrentDeliveryId(this.deliveryId);

              this.eligibilitySuccess = true;

              // Auto select 1st slot available
              if(!this.slotsChoiceActive){
                
                let delivery = {
                  start: new Date(response.data.slots[0].start),
                  end: new Date(response.data.slots[0].end),
                  //interventionProductId: segment.eventRange.def.extendedProps.interventionProductId,
                  agencyId: response.data.agency.agency_id,
                  selectedHours: response.data.slots[0].title,
                  slotId: response.data.slots[0].slotId,
                  fakeSlot: 1
                  //additionalInfo: segment.eventRange.def.extendedProps.additionalInfo,
                };

                this.setDelivery(delivery);
                this.setPreprendCartInterventionSlots(this.isZeborne);
              }

              if (this.needReload) {
                this.needReloadData = false;
              }
            } else {
              this.eligibilitySuccess = false;
              this.errorMessage = response.data;
            }
            this.toogleSpinner();
          })
          .then(()=>{
            this.$el.querySelector("#postal-code").scrollIntoView({behavior: "smooth"})
          })
          .catch((e) => {
            /** Error Message */
            /* this.$fire({
              title: "Oups",
              text: "Impossible de charger les disponibilités",
              type: "error",
              timer: 1500,
              position: "top-end",
            }); */
            console.log(e)

            this.toogleSpinner();
          });
    },

    async saveWizard() {
      this.hasStrapiForm = this.wizardSrapiForm && this.wizardSrapiForm.length > 0;

      if(this.isLead || this.fromLanding) {
        this.toogleSpinner();
        
        // Gtm Event
        if(!this.hasStrapiForm) {
          this.dataLayerEvent('adress');
        } 
      }

      const wizardResponse = await this.$store.dispatch("doSaveWizard");

      if (wizardResponse.error){
        this.$fire({
          title: "Oups",
          text: wizardResponse.error,
          type: "error",
          showConfirmButton: true,
        });
        
        if(this.isLead || this.fromLanding) {
          this.toogleSpinner()
        }
      }
        
    },
    prevStep() {
      this.step = 2;
      this.setWizardFillPercent(100);
    },
    nextStep() {
      this.hasStrapiForm = this.wizardSrapiForm && this.wizardSrapiForm.length > 0;

      this.step = 3;
      this.setWizardFillPercent(this.getWizardPercentFillLast);

      if(this.hasStrapiForm) {
        // Gtm Event
        this.dataLayerEvent('adress');
      } 
    },

    async checkInterventionAvailability() {
      let interventionInfos = await InstanceApi.get('mcp/cart/intervention');

      if(!interventionInfos.data.can_process_order) {
        await this.handleEmptyInterventionDate();
        this.loadSpinner === false ? this.toogleSpinner() : null;
      }
    },

    async handleEmptyInterventionDate() {
      this.step = 1;
      this.verifyEligibility(this.postalCodeValue);
      this.error_slot_process = true;
      this.errorMessage = "Une erreur est survenue, veuillez sélectionnez une nouvelle date d'intervention"
    },

  /**
   * Handle tab change on landing to avoid empty slot issue
   */
    tabFocusEvent() {
        document.addEventListener('visibilitychange', (ev) => {
          if(this.step >= 2 && document.visibilityState === 'visible') {
            this.checkInterventionAvailability()
          }
        });
    },


  /**
   * Gtm - Push event to  datalayer
   * @param {string} eventName  
   */
    dataLayerEvent(eventName) {
        let gtmDatasFormat = {
          add_to_cart: "ecommerce",
          postal_code: "product",
          adress: "product",
        };

        let customDatasToSave = this.getGtmDatasToSave(eventName);
        let customDatasToPersist = this.getGtmDatasToPersist(eventName);

        if(window.McpGtm) McpGtm.pushCustomDataLayer(eventName, customDatasToSave, customDatasToPersist, gtmDatasFormat[eventName]);

    },

  /**
   * Gtm - Get datas depends on event,
   * persist (save in localStorage)
   * @param {string} eventName
   * @return {Object}
   */
    getGtmDatasToPersist(eventName) {
      let customDatasToPersist = {
        add_to_cart:  {
                        option_name: this.deliveryType,
                        option_value: this.productShippingList[this.deliveryType]?.prices?.final_price[this.productCurrentTva],
                      },
        postal_code:  {
                        price: this.ProductCurrentPrice,
                        quantity: this.productPreprendCatQty,
                        value: this.currentCartTotal,
                        postal_code: this.postalCodeValue,
                      },
        adress:       {
                        professional: this.wizardRequiredInfo.isPro,
                        newsletter_accepted: this.wizardRequiredInfo.proxiserve_optin 
                      },
      };

      return customDatasToPersist[eventName];
    },

  /**
   * Gtm - Get datas depends on event,
   * @param {string} eventName
   * @return {Object}
   */
    getGtmDatasToSave(eventName) {
      let productDiscount = this.productShippingInfo.prices.price ? 
                                  this.productShippingInfo.prices.price[this.productCurrentTva] - this.ProductCurrentPrice : 
                                  0;
      
      let customDatasToSave = {
        add_to_cart:    {
                          ecommerce: {
                            value: this.currentCartTotal,
                            itemsQuantity: this.productPreprendCatQty,
                            /* items: {
                                price:      this.ProductCurrentPrice,
                                discount:   parseFloat(productDiscount.toFixed(2)),
                                quantity:   this.productPreprendCatQty,
                              }, */
                            
                          },
                        },
        postal_code:    {},
        adress:         {},
      }

      return customDatasToSave[eventName];
    },

    preventPostalCodeMaxLength,

    ...mapActions(["setSelectedDeliveryAgenciesData"]),
    ...mapActions(["setSelectedDeliveryCalendarData"]),
    ...mapActions(["setSelectedDeliveryPostalCode"]),
    ...mapActions(["setSelectedDeliveryId"]),
    ...mapActions(["setCurrentDeliveryId"]),
    ...mapActions(["setPreprendCartDeliveryOnly"]),
    ...mapActions(["setWizardFillPercent"]),
    ...mapActions(["setWizardFillPercentLast"]),
    ...mapActions(["setDelivery"]),
    ...mapActions(["setPreprendCartInterventionSlots"]),
    ...mapActions(["initStrapiForm"]),
  },
  
};
</script>
